import type { DateTime } from 'luxon';
import type { FieldProps } from 'formik';
import type { DateRange, DateRangeCalendarProps as MuiDateRangePickerProps } from '@mui/x-date-pickers-pro';

export interface FDateRangePickerProps
  extends FieldProps<DateRange<DateTime>, any>,
  Omit<MuiDateRangePickerProps<DateTime>, 'name' | 'value' | 'error'> {
}

export const fieldToDateRangePicker = ({
  field: { onChange: _onChange, ...field },
  form: {
    isSubmitting, setFieldValue, setFieldTouched,
  },
  meta,
  disabled,
  onChange,
  ...props
}: FDateRangePickerProps): MuiDateRangePickerProps<DateTime> => {
  const defaultOnChange = (date: DateRange<DateTime>) => {
    // Do not switch this order, otherwise you might cause a race condition
    // See https://github.com/formium/formik/issues/2083#issuecomment-884831583
    void setFieldTouched(field.name, true, false);
    void setFieldValue(field.name, date, true);
  };

  return {
    disabled: disabled ?? isSubmitting,
    onChange: onChange ?? defaultOnChange,
    ...field,
    ...props,
  };
};
